<!--
 * @Description: DeepLink Banner 组件
 * @Author: shiduobin
 * @Date: 2025-12-18 19:51:52
 * @LastEditors: shiduobin
 * @LastEditTime: 2026-01-08 16:49:11
-->
<template>
  <div class="deep-link-banner">
    <img v-img-error v-http2 :src="deepLinkBannerImg" alt="" class="deep-link-banner-icon" />
    <div class="deep-link-banner-content">
      <!-- PM 要求固定英文文案 -->
      <div class="deep-link-banner-title">DIDI</div>
      <div class="deep-link-banner-desc">
        {{
          $t('FoodC_Maps_ntji_abnD', {
            DIDI: '&nbsp;DiDi&nbsp;',
          })
        }}
      </div>
    </div>
    <div class="deep-link-banner-btn" @click="buttonHandleClick">
      {{ $t('FoodC_Maps_IpRR_NWPj') }}
    </div>
  </div>
</template>

<script>
import deepLinkBannerImg from './images/didi-icon.png'
import { requestCommonParams } from '@/lib/request/requestCommonParams'
import { getLocalStorage } from '@/utils/localStorage'
import { DDL_CODE_KEY } from './constant'
import { getDeviceOs } from '@/utils/os'
import api from '@/api'
export default {
  name: 'DeepLinkBanner',
  props: {
    customerOmegaParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      deepLinkBannerImg,
      globalParams: requestCommonParams(),
      ddlCode: null,
      /**
       * DeepLink Banner 跳转链接映射表
       */
      jumpLinkMap: {
        /**
         * 唤端 schema 协议
         */
        urlScheme: '',
        /**
         * 应用商店下载链接
         */
        appStoreUrl: '',
      },
    }
  },
  computed: {
    omegaParams() {
      return {
        city_id: this.globalParams?.cityId,
        ...this.customerOmegaParams,
      }
    },
  },
  watch: {},
  created() {
    this.ddlCode = getLocalStorage(DDL_CODE_KEY)
    this.getDeepLinkUrl()
  },
  mounted() {
    // 延迟上报，等待 DOM 渲染完成
    setTimeout(() => {
      this.$trackEvent({
        eventId: 'sailing_c_x_shop_top_black_bar_sw',
        eventLabel: '商家页顶部进端入口小黑条曝光',
        attrs: { ...this.omegaParams },
      })
    }, 500)
  },
  methods: {
    /**
     * @description: 获取 DeepLink Banner 链接
     * @return {*}
     */
    async getDeepLinkUrl() {
      const deviceOs = getDeviceOs()
      const res = await api.getDeepLink({ ddlCode: this.ddlCode, osType: deviceOs })
      if (res?.urlScheme) {
        this.jumpLinkMap = {
          urlScheme: res?.urlScheme,
          appStoreUrl: res?.appStoreUrl,
        }
      }
    },

    /**
     * @description: 唤端
     * @return {*}
     */
    async openDeepLinkBanner() {
      window.location.href = this.jumpLinkMap.urlScheme
      setTimeout(() => {
        // Safari 安全机制，在异步操作或回调函数中调用 window.open，会拦截
        window.location.href = this.jumpLinkMap.appStoreUrl
      }, 3000)
    },

    /**
     * @description: 点击 DeepLink Banner 按钮回调
     * @return {*}
     */
    async buttonHandleClick() {
      this.$trackEvent({
        eventId: 'sailing_c_x_shop_top_black_bar_ck',
        eventLabel: '商家页顶部进端入口小黑条中按钮点击',
        attrs: { ...this.omegaParams },
      })
      // 如果初始化没有拿到 urlScheme，重新请求一次
      if (!this.jumpLinkMap.urlScheme) {
        await this.getDeepLinkUrl()
      }
      this.openDeepLinkBanner()
    },
  },
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
